import {useCallback, useMemo} from "react";
import * as microsoftTeams from "@microsoft/teams-js";
import { jwtDecode } from "jwt-decode";
import {AuthSetup} from "../authConfig";

export const useTeamsAuth = (authSetup: AuthSetup) => {
    const getToken = useCallback(async () => {
        return await microsoftTeams.authentication.getAuthToken({});
    }, []);

    const getHeaders = useCallback(async (): Promise<Record<string, string>> => {
        const token = await getToken();
        const headers: Record<string, string> = {};
        if (token != null) {
            headers["Authorization"] = `Bearer ${token}`;
        }
        return headers;
    }, [getToken]);

    const isLoggedIn = useCallback(() => {
        // Teams auth doesn't provide a way to check if the user is logged in, so we assume they are if we can get a token
        return true;
    }, []);

    const getUserId = useCallback(async () => {
        const token = await microsoftTeams.authentication.getAuthToken({})
        if (token == null) {
            return null;
        }
        const decodedToken = jwtDecode<{ upn?: string, name?: string }>(token);


        return decodedToken.upn ?? null;
    }, []);

    const getActiveAccount = useCallback(async () => {
        const token = await microsoftTeams.authentication.getAuthToken({})
        if (token == null) {
            return null;
        }
        const decodedToken = jwtDecode<{ upn?: string, name?: string }>(token);
        return {
            id: decodedToken.upn ?? null,
            name: decodedToken.name ?? null,
        };

    }, []);

    const loginPopup = useCallback(async () => {
        // Teams auth doesn't provide a way to trigger a login popup, so we assume the user is already logged in
    }, []);

    const logout = useCallback(async () => {
        // Teams auth doesn't provide a way to log out, so we can't do anything here
    }, []);


    const refreshToken = useCallback(async () => {
        // Teams auth doesn't provide a way to refresh the token, so we can't do anything here
    }, []);

    return useMemo(() => {
        return {
            getToken,
            getHeaders,
            isLoggedIn,
            getActiveAccount,
            loginPopup,
            logout,
            canLogout: false,
            getUserId,
            refreshToken
        }
    }, [getToken, getHeaders, isLoggedIn, logout, getActiveAccount, getUserId, loginPopup, refreshToken]);

}